<div class="dialog">

  <div class="dialog__header clickable">
    <span>Edição em massa</span>
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <span>Edite todas propostas de forma geral, caso precise<br> ainda será possível editar cada campo manualmente.</span>

  <form [formGroup]="form" class="dialog__container">

    <div class="input-container">
      <mat-form-field class="input mat-datapicker" style="width: 100%;">
        <mat-label class="mb-xs">Data Sugerida Início</mat-label>
        <input matInput [matDatepicker]="releaseDate" formControlName="suggestedStartDate"
          (keypress)="keypressDate($event)" placeholder="DD/MM/AAAA" />
        <mat-datepicker-toggle matIconSuffix [for]="releaseDate"></mat-datepicker-toggle>
        <mat-datepicker #releaseDate></mat-datepicker>
      </mat-form-field>
    </div>


    <button [disabled]="!isSaveUpdateButtonEnabled()" (click)="massEdit()" class="edit_button" type="button">
      <span>Aplicar para todos</span>
    </button>
  </form>
</div>